import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ExpandedCardComponent} from "./expanded-card.component";
import {CardModule} from "../../../modules/core/component/card/card.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        CardModule
    ],
    declarations: [
        ExpandedCardComponent,
    ],
    exports: [
        ExpandedCardComponent,
        CardModule
    ],
})
export class ExpandedCardModule {}